<template>
    <div>
        <div class="first-flush-content search-row" ref="searchform">
            <div class="search-wrap" ref="searchwrap">
                <div class="container">
                    <div class="d-flex flex-fill mobile">
                        <button class="search-toggle btn btn-link d-flex" @click="mobileSearchToggle"><svg width="1.2em" height="1.2em" viewBox="0 0 16 16" class="bi bi-arrow-down-up mr-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M11 3.5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5z"/><path fill-rule="evenodd" d="M10.646 2.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L11 3.707 8.354 6.354a.5.5 0 1 1-.708-.708l3-3zm-9 7a.5.5 0 0 1 .708 0L5 12.293l2.646-2.647a.5.5 0 1 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 0-.708z"/><path fill-rule="evenodd" d="M5 2.5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-1 0V3a.5.5 0 0 1 .5-.5z"/></svg> Filters</button>
                        <div class="d-flex flex-row">
                            <a href="#" data-toggle="modal" data-target="#shareModal" class="d-inline-block"><img :src="base_url + 'assets/img/share-alt.svg'" style="height: 1.2em; width: 1.2em;" alt=""></a>
                            <a v-if="!isLoggedIn" href="#" data-toggle="modal" data-target="#loginModal" class="d-inline-block border-right border-left"><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-heart-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/></svg></a>
                            <p v-if="isLoggedIn" @click="saveSearch(false)" class="d-inline-block border-right border-left mb-0"><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-heart-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/></svg></p>
                            <a v-if="!isLoggedIn" href="#" data-toggle="modal" data-target="#propertyAlertModal" class="d-inline-block pr-0"><img :src="base_url + 'assets/img/alarm.svg'" style="height: 1.1em; width: 1.1em;" alt=""></a>
                            <p v-if="isLoggedIn" @click="saveSearch(true)" class="d-inline-block mb-0 pr-0"><img :src="base_url + 'assets/img/alarm.svg'" style="height: 1.1em; width: 1.1em;" alt=""></p>
                        </div>
                    </div>
                    <div class="d-flex flex-fill flex-wrap controls">
                        <div class="location d-inline-block flex-fill">
                            <searchable-dropdown ref="locationselect" v-on:item-selected="selectedLocation" :default="search.location" :countries="countries" :cities="cities" :towns="towns" placeholder="Type your search location"></searchable-dropdown>
                        </div>
                        <div class="type d-inline-block">
                            <select class="form-control custom-select" v-model="search.propertyType">
                                <option value="0">Property Type</option>
                                <option v-for="type in data.propertyTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
                            </select>
                        </div>
                        <div class="price d-inline-block">
                            <select class="form-control custom-select" v-model="search.minPrice">
                                <option value="0">Min Price</option>
                                <option v-for="n in data.minPrices.length" :key="n" :value="data.basePrices[(n - 1)]">{{ renderCurrency(data.minPrices[(n - 1)]) }}{{ data.basePrices[(n - 1)] == 20000000 ? "+" : "" }}</option>
                            </select>
                        </div>
                        <div class="price d-inline-block">
                            <select class="form-control custom-select" v-model="search.maxPrice">
                                <option value="0">Max Price</option>
                                <option v-for="n in data.maxPrices.length" :key="n" :value="data.basePrices[(n - 1)]">{{ renderCurrency(data.maxPrices[(n - 1)]) }}{{ data.basePrices[(n - 1)] == 20000000 ? "+" : "" }}</option>
                            </select>
                        </div>
                        <div class="bed d-inline-block">
                            <select class="form-control custom-select br-md-none" v-model="search.beds">
                                <option value="0">Beds</option>
                                <option v-for="bed in data.beds" :key="bed" :value="bed">{{ bed }}</option>
                            </select>
                        </div>
                        <button type="submit" class="btn btn-green" @click="updateSearch">Update Search</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row placeholder-search-slider" v-if="sliderLoading">
                <div class="col-12 col-md-3">
                    <div class="placeholder d-flex align-items-center">
                        <div class="p-box w-100"></div>
                    </div>
                </div>
                <div class="col-md-3 no-r2-mobile" v-for="n in 3" :key="n">
                    <div class="placeholder d-flex align-items-center">
                        <div class="p-box w-100"></div>
                    </div>
                </div>
            </div>
            <VueSlickCarousel v-bind="sliderSettings" class="categories" v-if="!sliderLoading && sliderContent && sliderContent.length > 0">
                <div class="category d-flex align-items-center" @click="setPropertyTypeTo(content.property_type_id)" v-for="content in sliderContent" :key="content.property_type_id">
                    <img :src="'/assets/img/property-types/' + content.type.slug + '.jpg'" :alt="content.type.name + 'Category'">
                    <div class="pl-4">
                        <h3>{{ content.type.plural }}</h3>
                        <p class="mb-0">{{ content.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} Properties</p>
                    </div>
                </div>
                <template #prevArrow>
                    <div class="slick-left-arrow slick-arrow d-flex align-items-center justify-content-center"><img src="/assets/img/left-arrow-min.png" alt="Left Arrow Icon"></div>
                </template>
                <template #nextArrow>
                    <div class="slick-right-arrow slick-arrow d-flex align-items-center justify-content-center"><img src="/assets/img/right-arrow-min.png" alt="Right Arrow Icon"></div>
                </template>
            </VueSlickCarousel>
        </div>
        <div v-if="!sliderLoading && (!sliderContent || sliderContent.length <= 0)" class="search-mob-spacing"></div>
    </div>
</template>

<script>
import {formatToTitleCase, formatForURL, formatLocationForURL, formatForCurrency} from '../Helpers';
import SearchableDropdown from '../components/SearchableDropdown.vue';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
    name: 'search-form',
    data() {
        return {
            isLoggedIn: false,
            searchIsActive: false,
            base_url: '',
            current_url: '',
            countries: [],
            cities: [],
            towns: [],
            data: {
                locations: [],
                propertyTypes: [],
                beds: [],
                minPrices: [],
                maxPrices: [],
                basePrices: []
            },
            search: {
                location: '',
                propertyType: 0,
                beds: 0,
                minPrice: 0,
                maxPrice: 0
            },
            search_old: {
                location: '',
                propertyType: 0,
                beds: 0,
                minPrice: 0,
                maxPrice: 0
            },
            sliderLoading: false,
            sliderContent: [],
            sliderSettings: {
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 4,
                centerMode: false,
                variableWidth: false,
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 1300,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 760,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            }
        };
    },
    components: {
        SearchableDropdown,
        VueSlickCarousel
    },
    created() {
        this.isLoggedIn = window.Propuno.isLoggedIn;
        this.current_url = window.Propuno.base_url;
        this.base_url = window.Propuno.base_url;
        this.data.propertyTypes = window.Propuno.property_types;
        //this.data.locations = window.Propuno.locations;
        this.data.minPrices = window.Propuno.sale_prices;
        this.data.maxPrices = window.Propuno.sale_prices;
        this.data.beds = window.Propuno.beds;
        this.data.basePrices = window.Propuno.sale_base_prices;

        this.countries = window.Propuno.countries;
        this.cities = window.Propuno.cities;
        this.towns = window.Propuno.towns;

        var locations = window.Propuno.countries;
        locations = locations.concat(window.Propuno.cities);
        locations = locations.concat(window.Propuno.towns);
        this.data.locations = locations.filter(function(item, pos) {
            return locations.indexOf(item) == pos;
        });

        /*
        for (var i = 0; i < this.data.locations.length; i++) {
            var location = String(this.data.locations[i]);
            if (location.includes(", ")) {
                var check = location.split(", ");
                if (check.length >= 3) {
                    this.towns.push(location);
                } else {
                    this.cities.push(location);
                }
            } else {
                this.countries.push(location);
            }
        }
        */

        this.loadSearchFormFromURL();

        this.sliderContent = window.PropertyTypes;

        window.addEventListener('propertyTypesData', event => {
            this.sliderContent = event.detail;
            this.sliderLoading = false;
        });

        window.onpopstate = (event) => {
            window.Lozad.observe();
            this.loadSearchFormFromURL();
            window.Livewire.emit('searchChanged', [
                this.search.location,
                this.search.propertyType,
                this.search.beds,
                this.search.minPrice,
                this.search.maxPrice
            ]);
        };
    },
    methods: {
        setPropertyTypeTo(id) {
            this.search.propertyType = id;
            this.updateSearch();
        },
        selectedLocation(value) {
            this.search.location = value;
        },
        saveSearch(alert) {
            var call = alert ? '/api/toggle-search-alert' : '/api/toggle-saved-search';

            axios.post(call, {
                    'location': this.search.location,
                    'type': this.search.propertyType,
                    'beds': this.search.beds,
                    'price_from': this.search.minPrice,
                    'price_to': this.search.maxPrice,
                    'url': this.current_url
                })
                .then((response) => {
                    this.$toast.open({
                        message: response.data.message,
                        type: 'success'
                    });
                }).catch((error) => {
                    this.$toast.open({
                        message: 'Something went wrong',
                        type: 'error'
                    });
                });
        },
        renderCurrency(val) {
            return formatForCurrency(val);
        },
        loadSearchFormFromURL() {
            this.resetSearchForm();
            var url = window.location.href.includes("?") ? window.location.href.substring(0, window.location.href.indexOf("?")) : window.location.href;
            var segments = url.split("/");

            for (var i = 0; i < segments.length; i++) {
                if (segments[i].toLowerCase().includes("-for-sale")) {
                    var type = segments[i].substring(0, segments[i].indexOf("-for-sale")).toLowerCase();
                    var validatedType = this.data.propertyTypes.filter((t) => {
                        return t.slug.toLowerCase() == type;
                    });

                    if (validatedType && validatedType[0]) {
                        this.search.propertyType = validatedType[0].id;
                        this.search_old.propertyType = validatedType[0].id;
                    }
                } else if (segments[i].toLowerCase() == "in" && segments[i + 1]) {
                    var rawLocation = decodeURIComponent(segments[i + 1]).toString().toLowerCase().split("-").join(" ").toLowerCase();
                    this.search.location = formatToTitleCase(rawLocation);
                    this.search_old.location = formatToTitleCase(rawLocation);
                    var validatedLocation = this.data.locations.filter((l) => {
                        return l.split(",").join("").split(" / ").join(" ").split(" - ").join(" ").split("-").join(" ").toLowerCase() == rawLocation;
                    });

                    if (validatedLocation && validatedLocation[0]) {
                        this.search.location = validatedLocation[0];
                        this.search_old.location = validatedLocation[0];
                    } else {
                        this.search.location = formatToTitleCase(rawLocation);
                        this.search_old.location = formatToTitleCase(rawLocation);
                    }
                } else if (segments[i].toLowerCase() == "beds" && segments[i + 1] && !isNaN(parseInt(segments[i + 1])) && parseInt(segments[i + 1]) >= 1) {
                    this.search.beds = parseInt(segments[i + 1]);
                    this.search_old.beds = parseInt(segments[i + 1]);
                } else if (segments[i].toLowerCase() == "min" && segments[i + 1] && !isNaN(parseInt(segments[i + 1])) && parseInt(segments[i + 1]) >= 1) {
                    this.search.minPrice = parseInt(segments[i + 1]);
                    this.search_old.minPrice = parseInt(segments[i + 1]);
                } else if (segments[i].toLowerCase() == "max" && segments[i + 1] && !isNaN(parseInt(segments[i + 1])) && parseInt(segments[i + 1]) >= 1) {
                    this.search.maxPrice = parseInt(segments[i + 1]);
                    this.search_old.maxPrice = parseInt(segments[i + 1]);
                } else if (segments[i].toLowerCase() == "page" && segments[i + 1] && !isNaN(parseInt(segments[i + 1])) && parseInt(segments[i + 1]) >= 1) {
                    this.pagination.page = parseInt(segments[i + 1]);
                }
            }

            if(this.$refs && this.$refs.locationselect) {
                this.$refs.locationselect.search = this.search.location;
            }
        },
        resetSearchForm() {
            this.sliderContent = [];

            this.search = {
                location: '',
                propertyType: 0,
                beds: 0,
                minPrice: 0,
                maxPrice: 0
            };

            this.search_old = {
                location: '',
                propertyType: 0,
                beds: 0,
                minPrice: 0,
                maxPrice: 0
            };
        },
        mobileSearchToggle: function() {
            if (this.searchIsActive) {
                this.$refs.searchwrap.classList.add('is-active');
            } else {
                this.$refs.searchwrap.classList.remove('is-active');
            }
            this.searchIsActive = !this.searchIsActive;
        },
        updateSearch: function() {
            if (this.searchIsActive) {
                this.$refs.searchwrap.classList.remove('is-active');
                this.searchIsActive = false;
            }

            if (JSON.stringify(this.search) != JSON.stringify(this.search_old)) {
                if (this.search.location != this.search_old.location) {
                    this.sliderLoading = true;
                }

                this.search_old = {
                    location: this.search.location,
                    propertyType: this.search.propertyType,
                    beds: this.search.beds,
                    minPrice: this.search.minPrice,
                    maxPrice: this.search.maxPrice
                };

                this.updateURL();
                window.Livewire.emit('searchChanged', [
                    this.search.location,
                    this.search.propertyType,
                    this.search.beds,
                    this.search.minPrice,
                    this.search.maxPrice
                ]);
            }
        },
        updateURL: function() {
            var url = this.base_url;

            var propertyTypeSlugForURL = "property";
            var propertyTypePlural = "Property";
            if (this.search.propertyType != 0) {
                var slug = this.data.propertyTypes.filter((t) => {
                    return t.id == this.search.propertyType;
                });

                if (slug && slug[0]) {
                    propertyTypeSlugForURL = slug[0].slug;
                    propertyTypePlural = slug[0].plural;
                }
            }

            url += propertyTypeSlugForURL + "-for-sale/";

            if (this.search.location) {
                url += "in/" + formatLocationForURL(this.search.location);
            }
            if (this.search.beds != 0) {
                url += "beds/" + formatForURL(this.search.beds);
            }
            if (this.search.minPrice != 0) {
                url += "min/" + formatForURL(this.search.minPrice);
            }
            if (this.search.maxPrice != 0) {
                url += "max/" + formatForURL(this.search.maxPrice);
            }

            document.title = propertyTypePlural + this.searchTitle + ' - Luxury ' + propertyTypePlural + " " + (this.search.location ? "in " + this.search.location :  window.Propuno.defaultSearchLocation);
            var state = {
                title: this.searchTitle,
                url: url
            };

            history.pushState(state, this.searchTitle, url);
            this.current_url = url;
        }
    },
    computed: {
        searchTitle() {
            return " for Sale " + (this.search.location ? "in " + this.search.location : window.Propuno.defaultSearchLocation);
        }
    }
}
</script>
